import React from 'react';
import PropTypes from 'prop-types';
import Translate from 'components/Translate';
import AlternateBadge from '../AlternateBadge';

const RelatedBadges = (props) => {
    const { badge } = props;

    if (badge.relatedBadges.length === 0) {
        return null;
    }

    return (
        <div className="related-badges-list">
            <h4 className="h5">
                <Translate ns="badges" content="related_badges" />
            </h4>

            {renderRelatedBadges(props)}
        </div>
    );
};

const renderRelatedBadges = (props) => {
    const { badge } = props;

    return badge.relatedBadges.map((badge, index) => {
        return (
            <AlternateBadge
                {...props}
                key={index}
                badge={badge}
                available={!badge.earnedByMe}
                displayName={badge.earnedByMe ? props.viewerSocialProfile.displayName : null}
                viewer={null}
                connection={null}
                displayViewer={false}
                displayConnection={false}
            />
        );
    });
};

RelatedBadges.propTypes = {
    badge: PropTypes.object.isRequired
};

export default RelatedBadges;
